export default __webpack_public_path__ + "static/media/Ballroll_00117.31890093.png";